// Spatial field prefixes
export const SPATIAL_PREFIX = 'spatial:';
export const SPATIAL_DECKS = `${SPATIAL_PREFIX}decks`;
export const SPATIAL_PAINT = `${SPATIAL_PREFIX}paintRegions`;
export const SPATIAL_WORKPACK = `${SPATIAL_PREFIX}workpacks`;

export const MAX_VISIBLE_ITEMS = 7;
export const MAX_DROPDOWN_HEIGHT = '300px';
export const VISIBLE_DROPDOWN_ITEMS = 5;
export const DROPDOWN_ITEM_HEIGHT = '40px';
export const SEARCH_DEBOUNCE_MS = 500;
export const MIN_SEARCH_INPUT_WIDTH = '150px';

// Spatial field names for display
export const SPATIAL_FIELD_NAMES = {
  [SPATIAL_DECKS]: 'Decks',
  [SPATIAL_PAINT]: 'Paint Blocks',
  [SPATIAL_WORKPACK]: 'Workpacks',
};
